/**
 * The Ajuda and Notícias pages (ichegoubr.com/ajuda, /noticias). Answers mirror the apps and the
 * Termos de Uso (legal.ts), with no amounts: prices, fees and limits are remote config.
 */
export type HelpTopic = { id: string; title: string; items: { q: string; a: string }[] };

export const HELP: HelpTopic[] = [
  {
    id: "passageiros",
    title: "Corridas",
    items: [
      { q: "Quando vejo o preço da corrida?", a: "Antes de pedir. O app mostra o valor de cada categoria para o seu trajeto, já com a tarifa dinâmica quando houver, e é esse valor que você paga." },
      { q: "Como posso pagar?", a: "No Pix, pago antes de procurarmos o motorista. No cartão, disponível depois de algumas corridas pagas e cobrado ao fim da corrida. Ou em Pagar na hora, em dinheiro ou Pix com o motorista no fim da corrida, quando a opção aparecer no app." },
      { q: "Posso cancelar uma corrida?", a: "Sim. É gratuito logo após o aceite do motorista e quando ele está muito atrasado em relação ao tempo prometido. Fora disso, pode haver uma taxa, informada no app antes de você confirmar." },
      { q: "O que é o código de embarque?", a: "São 4 dígitos que aparecem no seu app. A corrida só começa quando o motorista confirma esse código, então confira também o veículo e a placa antes de entrar." },
      { q: "Como aviso alguém sobre a minha viagem?", a: "Compartilhe a corrida com seus contatos de confiança: eles acompanham o trajeto ao vivo, e avisamos se a rota mudar." },
      { q: "Estou em perigo. O que eu faço?", a: "Ligue 190. O botão Emergência do app também avisa a central do ichegou e seus contatos de confiança, mas não substitui os serviços públicos de emergência." },
    ],
  },
  {
    id: "envios",
    title: "Envios",
    items: [
      { q: "Como funciona uma entrega?", a: "O motorista tira foto na coleta e na entrega, e quem recebe informa um código. Você acompanha tudo pelo mapa." },
      { q: "O que eu não posso enviar?", a: "Itens proibidos por lei, perigosos, perecíveis sem embalagem adequada, dinheiro ou documentos de terceiros." },
    ],
  },
  {
    id: "motoristas",
    title: "Motoristas",
    items: [
      { q: "O que eu preciso para dirigir?", a: "CNH com EAR, o documento do veículo e uma chave Pix no seu CPF. Faça o cadastro pelo site, em Motorista, ou no app ichegou Motorista; aprovado o cadastro, você faz a prova de vida e já pode ficar online." },
      { q: "Quando eu recebo?", a: "O repasse é semanal, por Pix, toda terça. Se precisar antes, peça o saque na hora no app." },
      { q: "E quando o passageiro paga na hora?", a: "Seu ganho não muda. Se você ficar com o dinheiro, a comissão sai do próximo repasse. Se o passageiro não pagar, você recebe mesmo assim. Para não pegar essas corridas, desligue Aceitar pagamento na hora." },
      { q: "As gorjetas são minhas?", a: "Sim. As gorjetas e a taxa pet vão integralmente para você." },
    ],
  },
  {
    id: "conta",
    title: "Sua conta",
    items: [
      { q: "Quem pode ter uma conta?", a: "Maiores de 18 anos. Menores podem viajar acompanhados de um adulto responsável pela conta." },
      { q: "Como excluo minha conta?", a: "Em Conta → Privacidade → Excluir conta. Você tem 7 dias para desistir." },
    ],
  },
];

export type NewsPost = { id: string; date: string; title: string; body: string };

/** Newest first. The page says so plainly while there is nothing to publish. */
export const NEWS: NewsPost[] = [];
